import { CTAButton } from "../common/CTAButton";

type Step = {
  number: string;
  title: string;
  description: string;
};

type HowItWorksProps = {
  steps: Step[];
  cta: { label: string; href: string };
};

export function HowItWorksSection({ steps, cta }: HowItWorksProps) {
  return (
    <section className="bg-slate-950/95 py-24" aria-labelledby="how-heading">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
          <h2 id="how-heading" className="text-3xl font-semibold text-white sm:text-4xl">
            How AVUX works with you
          </h2>
          <p className="mt-4 text-slate-300">
            A systems-first approach that turns complex workflows into operationally sound experiences.
          </p>
        </div>
        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {steps.map((step) => (
            <article
              key={step.number}
              className="flex flex-col rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100"
            >
              <div className="text-5xl font-semibold text-emerald-300">{step.number}</div>
              <h3 className="mt-6 text-xl font-semibold text-white">{step.title}</h3>
              <p className="mt-4 text-sm text-slate-300">{step.description}</p>
            </article>
          ))}
        </div>
        <div className="mt-12">
          <CTAButton href={cta.href}>{cta.label}</CTAButton>
        </div>
      </div>
    </section>
  );
}
